/**
 * What a product line costs: its unit price, times how many of it.
 *
 * `products.price` is the price of one. That is what the field is labelled on
 * both order forms, what each of them totals a line by while it is being typed,
 * and what the server now calculates the order's amount from. Every surface
 * that puts money against a line has to multiply, or it contradicts the total
 * printed under it — which is exactly what the invoice and the order page did.
 *
 * Its own module, with no imports: the invoice renders through react-pdf under
 * a Node test environment and cannot pull in the DOM-side order primitives,
 * and one definition read by all three surfaces is the point.
 *
 * Tolerant of the API's strings — decimals arrive as `"2000.00"` — and of a
 * half-built line, which is worth 0 rather than NaN.
 */
export const lineAmount = (product) =>
  (Number(product?.price) || 0) * (Number(product?.unit ?? product?.quantity) || 0);
